export default __webpack_public_path__ + "static/media/안주6.5ff61e1d.png";